import { createAsyncThunk, current } from '@reduxjs/toolkit';
import { axiosInstance } from '../../../utils/axiosInterceptor';

export const initStateDeleteApplicationList = {
  deleteApplicationList: { data: null, loading: false, error: null },
};

export const deleteApplicationList = createAsyncThunk('user/deleteApplicationList', async (data, { rejectWithValue, fulfillWithValue }) => {
  return await axiosInstance
    .put(`${process.env.REACT_APP_SERVER_API}/vacancies/applications/deletion`, data, {
      headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
    })
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerDeleteApplicationList = {
  [deleteApplicationList.pending]: (state) => {
    // state.deleteApplicationList.data = null;
    state.deleteApplicationList.loading = true;
    state.deleteApplicationList.error = null;
  },
  [deleteApplicationList.fulfilled]: (state, action) => {
    state.deleteApplicationList.loading = false;
    state.deleteApplicationList.data = true;
    state.deleteApplicationList.error = null;
  },
  [deleteApplicationList.rejected]: (state, action) => {
    state.deleteApplicationList.loading = false;
    state.deleteApplicationList.error = action.payload;
  },
};
